import _ from 'lodash';
import { makeCell } from './gridUtill';
let fields = [];
let columns = [];

// 순번 (숨김 - 신규 항목과 기존 항목을 가른다)
makeCell(1, [{ field: 'idx', alias: '순번', indexExclusive: true }], fields, columns);
columns[columns.length - 1].visible = false;

const data = [
  {
    alias: '항목',
    field: 'index',
    width: '100',
  },
  {
    alias: '값',
    field: 'val',
  },
  {
    alias: '설명',
    field: 'description',
  },
  {
    alias: '사용여부',
    field: 'use_yn',
    width: '100',
  },
];
_.each(data, function (o) {
  o.indexExclusive = true;
  makeCell(1, [o], fields, columns, o.width);
});
const noneNo = true;
const noneHeader = true;
export { fields, columns, noneNo, noneHeader };
